module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/348.f7638477.png";